import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
    selector: 'app-generic-confirm-dialog',
    templateUrl: './generic-confirm-dialog.component.html',
    styleUrls: ['./generic-confirm-dialog.component.scss'],
    standalone: false
})
export class GenericConfirmDialogComponent implements OnInit {

  constructor(private router: Router,
    public dialogRef: MatDialogRef<GenericConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
  }

  buttonOneClicked() {
    if (this.data.routerLinkButtonOne != null)
      this.router.navigateByUrl(this.data.routerLinkButtonOne)

    this.dialogRef.close(false);
  }

  buttonTwoClicked() {
    if (this.data.routerLinkButtonTwo != null && this.data.queryParam != null)
      this.router.navigate([`${this.data.routerLinkButtonTwo}`], { queryParams: { ecommerce: this.data.queryParam } })
    else if (this.data.routerLinkButtonTwo != null)
      this.router.navigateByUrl(this.data.routerLinkButtonTwo)
    this.dialogRef.close(true);

  }
}
